import React from "react";
import { Eyebrow, Section } from "./SeoUI";

import modalImageOne from "../assets/modal-image-one.png";
import modalImageTryOn from "../assets/modal-image-try-on.png";
import modalImageTryOnTwo from "../assets/modal-image-try-on-two.png";

const VirtualTryOnSection = ({ variant = "algorithm" }) => {
  if (variant === "personal" || variant === "algorithm")
    return (
      <Section id="virtual-try-on" className="bg-white py-14 sm:py-24 md:ml-[175px]">
        <div className="grid items-start gap-12 md:grid-cols-[minmax(0,260px)_minmax(0,1fr)] md:gap-[175px] lg:grid-cols-[minmax(0,270px)_minmax(0,1fr)]">
          {/* Intentional solid-black phone preview, as in the reference. */}
          <div className="mx-auto w-full max-w-[316px] md:mx-0">
            <div
              role="img"
              aria-label="Virtual try-on preview placeholder"
              className="aspect-[217/420] w-full rounded-[30px] bg-[#111111] h-auto md:h-[516px]"
            />
          </div>

          <div className="min-w-0 md:pt-1">
            <Eyebrow>Module: virtual_try_on</Eyebrow>
            <h2 className="font-medium leading-tight tracking-[-.045em] text-[#313131] font-inter text-[28px] md:text-[32px]">
              See it on you, before you buy.
            </h2>
            <p className="mt-4 max-w-[600px] text-[13px] md:text-[15px] leading-[1.7] text-[#5C5C5C] font-inter">
              Eveness Try-On overlays real garments on your own photo — drape, length and shadow rendered in seconds. No more guessing whether the midi reads as midi on a 5'7" frame.            </p>

            <div className="mt-9 space-y-7">
              {[
                [
                  "01",
                  "STEP_01 — UPLOAD",
                  "Upload your photo",
                  "Drag in a full-body photo. Eveness extracts pose, proportions and skin tone — locally on your device.",
                ],
                [
                  "02",
                  "STEP_02 — OVERLAY",
                  "Try on any garment",
                  "Tap any product card. The Gavin Linen Midi Dress is rendered onto your figure with correct drape and shadow.",
                ],
                [
                  "03",
                  "STEP_03 — DECIDE",
                  "Buy or save to a board",
                  "Add to a Board, share with a friend, or check out — Eveness routes you straight to the brand.",
                ],
              ].map(([n, k, t, d]) => (
                <div key={n} className="flex gap-5">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded border border-[#E5E5E5] font-jetBrainsMono text-xs md:text-[13px]">
                    {n}
                  </div>
                  <div>
                    <div className="font-jetBrainsMono text-[10px] md:text-[11px] tracking-wider text-[#F26633]">
                      {k}
                    </div>
                    <h3 className="mt-1 text-[16px] md:text-[17px] font-medium font-inter text-[#313131]">{t}</h3>
                    <p className="mt-1 text-[12px] font-inter md:text-[13px] leading-5 text-[#5C5C5C]">
                      {d}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>
    );
  if (variant === "how") {
    return (
      <Section id="virtual-try-on" className="bg-white py-16 md:py-[76px]">
        <div className="grid grid-cols-1 items-start gap-8 md:grid-cols-[440px_minmax(0,1fr)] md:gap-[136px]">
          {/* Left: Virtual try-on preview */}
          <div className="mx-auto w-full max-w-[440px] md:mx-0">
            <div className="relative h-[616px] w-full overflow-hidden rounded-[8px] bg-[#F8F8F8] shadow-[0_4px_25px_rgba(0,0,0,0.07)]">
              {/* Main model image */}
              <img
                src={modalImageOne}
                alt="Model wearing a pink satin midi dress"
                className="absolute inset-0 h-full w-full object-cover object-top"
              />

              {/* Bottom preview overlay */}
              <div className="absolute bottom-[12px] left-[85px] z-10 flex flex-col items-start gap-[5px]">
                {/* Label */}
                <div className="rounded-[7px] bg-white px-[11px] py-[9px] shadow-[0_2px_8px_rgba(0,0,0,0.06)]">
                  <p className="font-inter text-[12px] md:text-[16px] font-normal leading-[27px] text-[#424242]">
                    AI Try-on before you buy
                  </p>
                </div>

                {/* Thumbnail images */}
                <div className="flex items-center gap-[6px]">
                  <div className="h-[85px] md:h-[114px] w-[85px] md:w-[114px] overflow-hidden rounded-[5px] bg-white">
                    <img
                      src={modalImageTryOn}
                      alt="Pink dress product preview"
                      className="h-full w-full object-cover object-top"
                    />
                  </div>

                  <div className="h-[85px] md:h-[114px] w-[85px] md:w-[114px] overflow-hidden rounded-[5px] bg-white">
                    <img
                      src={modalImageTryOnTwo}
                      alt="Customer virtual try-on photo"
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right: Section content */}
          <div className="min-w-0">
            {/* Eyebrow */}
            <div className="mb-[12px] flex items-center gap-[5px]">
              <span className="h-[4px] w-[4px] rounded-full bg-[#A3A3A3]" />
              <span className="font-spaceMono text-[10px] md:text-[11px] uppercase tracking-[0.12em] text-[#5C5C5C]">
                MODULE: VIRTUAL_TRY_ON
              </span>
            </div>

            {/* Heading */}
            <h2 className="font-inter text-[28px] font-medium leading-[42px] tracking-[-2%] text-[#313131] sm:text-[36px]">
              See it on you, before you buy.
            </h2>

            {/* Description */}
            <p className="mt-[12px] max-w-[600px] font-inter text-[12px] md:text-[15px] leading-[24px] text-[#5C5C5C]">
              Eveness Try-On overlays real garments on your own photo — drape,
              length and shadow rendered in seconds. No more guessing whether
              the midi reads as midi on a 5'7" frame.{" "}
            </p>

            {/* Steps */}
            <div className="mt-9 space-y-7">
              {[
                [
                  "01",
                  "STEP_01 — UPLOAD",
                  "Upload your photo",
                  "Drag in a full-body photo. Eveness extracts pose, proportions and skin tone — locally on your device.",
                ],
                [
                  "02",
                  "STEP_02 — OVERLAY",
                  "Try on any garment",
                  "Tap any product card. The Gavin Linen Midi Dress is rendered onto your figure with correct drape and shadow.",
                ],
                [
                  "03",
                  "STEP_03 — DECIDE",
                  "Buy or save to a board",
                  "Add to a Board, share with a friend, or check out — Eveness routes you straight to the brand.",
                ],
              ].map(([n, k, t, d]) => (
                <div key={n} className="flex gap-5">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded border border-[#E5E5E5] font-jetBrainsMono text-xs md:text-[13px]">
                    {n}
                  </div>
                  <div>
                    <div className="font-jetBrainsMono text-[10px] md:text-[11px] tracking-wider text-[#F26633]">
                      {k}
                    </div>
                    <h3 className="mt-1 text-[16px] md:text-[17px] font-medium font-inter text-[#313131]">{t}</h3>
                    <p className="mt-1 text-[12px] font-inter md:text-[13px] leading-5 text-[#5C5C5C]">
                      {d}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>
    );
  }
  return null;
};

export default VirtualTryOnSection;
